import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';

import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';

import App from './App';
import config from './config';
import reportWebVitals from './reportWebVitals';

import {store} from './app/store/store';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <StrictMode>
        <Provider store={store}>
            <BrowserRouter basename={config.basename}>
                <App />
            </BrowserRouter>
        </Provider>
    </StrictMode>
);

if (process.env.NODE_ENV === 'development') {
    reportWebVitals(console.log);
}
